import { apiCreate, apiDelete, apiGetList } from './ApiBaseActions';
export const API_GET_SLIDE_CLIPS = 'API_GET_SLIDE_CLIPS';
export const API_CREATE_SLIDE_CLIP = 'API_CREATE_SLIDE_CLIP';
export const API_DELETE_SLIDE_CLIP = 'API_DELETE_SLIDE_CLIP';
export const API_GET_SLIDE_BOARDS = 'API_GET_SLIDE_BOARDS';
export const API_CREATE_SLIDE_BOARDS = 'API_CREATE_SLIDE_BOARDS';
export const API_DELETE_MANY_SLIDE_BOARDS = 'API_DELETE_MANY_SLIDE_BOARDS';
export const API_DELETE_MANY_SLIDE_BOARD_CLIPS = 'API_DELETE_MANY_SLIDE_BOARD_CLIPS';
/**
 * clipの一覧を取得
 * @param params
 * @param meta
 * @returns {*}
 */
export const apiGetSlideClips = (params, meta) => apiGetList(API_GET_SLIDE_CLIPS, '/client/slide/clips', Object.assign({}, params), Object.assign({}, meta));
/**
 * clipを作成
 * @param pageId
 * @param meta
 * @returns {*}
 */
export const apiCreateSlideClip = (pageId, meta) => apiCreate(API_CREATE_SLIDE_CLIP, `/client/slide/clip_pages/${pageId}`, {}, Object.assign({}, meta));
/**
 * clipを削除
 * @param pageId
 * @param meta
 * @returns {*}
 */
export const apiDeleteSlideClip = (pageId, meta) => apiDelete(API_DELETE_SLIDE_CLIP, `/client/slide/clip_pages/${pageId}`, Object.assign({}, meta));
/**
 * スライドのボードの一覧を取得
 * @param params
 * @param meta
 * @returns {*}
 */
export const apiGetSlideBoards = (params, meta) => apiGetList(API_GET_SLIDE_BOARDS, '/client/slide/boards', Object.assign({}, params), Object.assign({}, meta));
/**
 * スライドのボードを作成
 * @param params
 * @param meta
 * @returns {*}
 */
export const apiCreateSlideBoards = (params, meta) => apiCreate(API_CREATE_SLIDE_BOARDS, '/client/slide/boards', Object.assign({}, params), Object.assign({}, meta));
/**
 * 複数のスライドのボードを削除
 * @param boardIds
 * @param meta
 * @return {*}
 */
export const apiDeleteManySlideBoards = (boardIds, meta) => apiDelete(API_DELETE_MANY_SLIDE_BOARDS, `/client/slide/boards/many/${boardIds}`, Object.assign({}, meta));
/**
 * スライドの中のクリップを複数削除
 * @param boardId
 * @param slideIds
 * @param meta
 * @return {*}
 */
export const apiDeleteManySlideBoardClips = (boardId, slideIds, meta) => apiDelete(API_DELETE_MANY_SLIDE_BOARD_CLIPS, `/client/slide/boards/${boardId}/many/${slideIds}`, Object.assign({}, meta));
